import { SVG, IconProps } from "../SVG";
import React from "react";

export const SpotCalendarCheckMark = ({
    color = "#13126C",
    spotColor = "#E4EDFE",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <g clipPath="url(#calendar_blue_check_mark_svg__a)">
            <path
                fill={spotColor}
                fillRule="evenodd"
                d="M28.698 9.816c-2.536-2.053-6.625-5.269-11.804-5.894-5.187-.619-11.941 1.3-13.605 5.227C1.641 13.077.538 13.242.68 23.452c-.3 7.265.13 12.14 4.33 14.354 3.61 1.902 19.228-.243 23.547-2.25 4.325-1.998 7.457-4.296 9.364-7.127 1.915-2.822 2.11-5.512 1.213-8.049-.911-2.538-2.91-4.937-4.898-6.269-1.987-1.332-2.985-2.24-5.537-4.295Z"
                clipRule="evenodd"
            />
            <rect
                width={28}
                height={25.2}
                x={6}
                y={7.8}
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.2}
                rx={2}
            />
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.2}
                d="M26.224 5v5.6M13.778 5v5.6M6 16.2h28M16 24.55l3.755 3.55L24.63 21"
            />
        </g>
    </SVG>
);
SpotCalendarCheckMark.displayName = "SpotCalendarCheckMark";
